 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"1bfc9850","2":"5e2a4920","3":"d7eeaac4","4":"78e521c3","5":"de71a805","6":"1a6924cd0c4cce722ca6e43d39f6abc39847b0ca","7":"252f366e","9":"95b64a6e","11":"component---src-pages-404-js","12":"component---src-pages-contact-js","13":"component---src-pages-shop-bmw-bluetooth-adapter-js","14":"component---src-pages-shop-faq-js","15":"component---src-site-index-js","16":"component---src-site-logs-0-x-001-first-pcb-design-js","17":"component---src-site-logs-0-x-001-from-idea-to-prototype-js","18":"component---src-site-logs-0-x-001-reducing-noise-js","19":"component---src-site-logs-0-x-001-testing-the-second-board-js","20":"component---src-site-logs-0-x-001-the-final-hardware-js","21":"component---src-site-logs-0-x-001-wrapping-up-js","22":"component---src-site-logs-0-x-002-bldc-introduction-js","23":"component---src-site-logs-0-x-002-block-commutation-js","24":"component---src-site-logs-0-x-002-component-selection-js","25":"component---src-site-logs-0-x-002-hardware-design-js","26":"component---src-site-logs-0-x-003-clock-design-js","27":"component---src-site-logs-0-x-003-display-modes-js","28":"component---src-site-logs-0-x-003-housing-and-assembly-js","29":"component---src-site-logs-0-x-003-let-there-be-light-js","30":"component---src-site-logs-0-x-003-redesign-and-pcb-js","31":"component---src-site-logs-0-x-004-configuration-manager-js","32":"component---src-site-logs-0-x-004-framework-introduction-js","33":"component---src-site-logs-0-x-004-https-requests-js","34":"component---src-site-logs-0-x-004-web-server-js","35":"component---src-site-logs-0-x-004-wifi-manager-js","36":"component---src-site-logs-0-x-005-hardware-design-js","37":"component---src-site-logs-0-x-005-logging-to-the-cloud-js","38":"component---src-site-logs-0-x-005-testing-the-sensor-js","39":"component---src-site-logs-0-x-005-using-deep-sleep-js","40":"component---src-templates-project-js"}[chunkId]||chunkId) + "-" + {"0":"10e83db2edaea7622690","1":"0a6a3072e98db84ac306","2":"c2943801fa559d43f891","3":"bedd727d237792612c99","4":"d66d51db4aa1f86b84cd","5":"bbc84c8492af94273f17","6":"b303ebb12342fbb95e17","7":"390bf8ee3d60b65c6afd","9":"06d17b30880d03165af2","11":"70a91eb0091d9f1f25be","12":"b501cdce0705604f3d9d","13":"f7c75463cf00be3b3418","14":"0f87b27529470440e08c","15":"57610238856d124a9f23","16":"28b5286e3661b93ac09b","17":"916389c33d29f6f03e07","18":"e1b70a364a87997235a5","19":"c50cd3cb0a9426695710","20":"63d404e8b68708b951e7","21":"1b87be70127535dff8ad","22":"6feb6c971ae45be14265","23":"ddd9cf3a14831ddcb929","24":"cacc61f8486ed1267dab","25":"2d920b78dc99e38a6431","26":"2fadadadf298db27af08","27":"40cec3ae9fa3cb94d6e7","28":"7034f399deb6d7c40e88","29":"1ce130dfa53cdf2bfa3f","30":"69b742413a17554fbf37","31":"5e35dda8cae0cde8512b","32":"46ca7e5cfb11a0240e5f","33":"2c3878a546375cf77895","34":"67ddc6d655525bcd48d4","35":"382d9c23148ef506a095","36":"c19675a676b78e1309ec","37":"c097ba31fd2e283598eb","38":"1af54fa627f6f9d6cd97","39":"9d9ee455cfb5e4074400","40":"15530878425224cffa39"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
